import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LanguageService } from '@service/language.service';
import { OpsAlarmMonitoringService } from '@service/ops-alarms/ops-alarm-monitoring.service';
import { ResponsiveService } from '@service/responsive.service';
import { SystemStatusSocketService } from '@service/system-status-socket.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-environment-settings',
    templateUrl: './environment-settings.component.html',
    styleUrls: ['./environment-settings.component.scss'],
    standalone: false,
})
export class EnvironmentSettingsComponent implements OnInit, OnDestroy {
    @ViewChild('envSettingsPanel') envSettingsPanel: ElementRef;

    currentLang: string;
    enviromentSettingOpen: boolean = false;
    statusPanelOpen: boolean = false;
    statusPanelIconInterval: number = 3000;
    statusPanelIcon: string = 'icon';

    statusAlarm = true;
    statusMaintenance = true;

    private destroySubscriptionSubject$ = new Subject<void>();

    constructor(
        public responsive: ResponsiveService,
        private languageService: LanguageService,
        private systemStatusSocket: SystemStatusSocketService,
        private alarmMonitoringService: OpsAlarmMonitoringService,
    ) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (
            this.enviromentSettingOpen &&
            !this.envSettingsPanel?.nativeElement.contains(event.target)
        ) {
            this.enviromentSettingOpen = false;
        }
    }

    ngOnInit(): void {
        this.currentLang = this.languageService.getCurrentLanguage().value;
        this.statusMaintenance = this.systemStatusSocket.getIsReceivingData();
        const alarms = this.alarmMonitoringService.getAlarms();
        this.statusAlarm = alarms.length == 0;
        this.updateIcon();

        this.alarmMonitoringService
            .onNewAlarm()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(() => {
                this.statusAlarm = false;
                this.updateIcon();
            });

        this.alarmMonitoringService.onAlarmsUpdated$
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe((v) => {
                const alarms = this.alarmMonitoringService.getAlarms();
                this.statusAlarm = alarms.length == 0;
                this.updateIcon();
            });

        this.systemStatusSocket
            .updateConnectionSubject()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe((status) => {
                this.statusMaintenance = status;
                this.updateIcon();
            });
    }

    ngOnDestroy(): void {
        this.destroySubscriptionSubject$.next();
        this.destroySubscriptionSubject$.complete();
    }

    setLanguage(code: string) {
        this.languageService.setCurrentLanguage(code);
        this.currentLang = this.languageService.getCurrentLanguage().value;
    }

    isEnvironmentSettingOpen() {
        if (this.responsive.isXLarge() || this.responsive.isXSmall()) {
            this.enviromentSettingOpen = false;
        }
        return this.responsive.isXLarge() || this.enviromentSettingOpen;
    }

    showStatusPanel() {
        this.statusPanelOpen = !this.statusPanelOpen;
    }

    onShownEvironmentSettings() {
        this.enviromentSettingOpen = !this.enviromentSettingOpen;
    }

    updateIcon() {
        this.statusPanelIcon = this.statusAlarm
            ? 'assets/icons/status-alarm-good.svg'
            : 'assets/icons/status-alarm-bad.svg';
        setInterval(() => {
            if (this.statusPanelIcon.startsWith('assets/icons/status-alarm')) {
                this.statusPanelIcon = this.statusMaintenance
                    ? 'assets/icons/status-maintenance-good.svg'
                    : 'assets/icons/status-maintenance-bad.svg';
            } else {
                this.statusPanelIcon = this.statusAlarm
                    ? 'assets/icons/status-alarm-good.svg'
                    : 'assets/icons/status-alarm-bad.svg';
            }
        }, this.statusPanelIconInterval);
    }
}
